import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppProvider } from './app/AppContext';
import { Layout } from './components/Layout';
import { config } from './config';
import { I18nProvider } from './i18n';
import { JoinPage } from './pages/JoinPage';
import { LobbyPage } from './pages/LobbyPage';
import { MatchPage } from './pages/MatchPage';
import { ReplayPage } from './pages/ReplayPage';

export function App() {
  return (
    <I18nProvider>
      <AppProvider>
        {/* basename 用編譯期注入的 base path，支援 /v/<version>/ 多版本並存 */}
        <BrowserRouter basename={config.basePath === '/' ? undefined : config.basePath}>
          <Layout>
            <Routes>
              <Route path="/" element={<LobbyPage />} />
              <Route path="/m/:matchId" element={<MatchPage />} />
              <Route path="/j/:code" element={<JoinPage />} />
              <Route path="/r/:matchId" element={<ReplayPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </AppProvider>
    </I18nProvider>
  );
}
